var map = {
	"./gallery_00.jpg": 4895,
	"./gallery_01.jpg": 4896,
	"./gallery_02.jpg": 4897,
	"./gallery_03.jpg": 4898,
	"./gallery_04.jpg": 4899,
	"./gallery_05.jpg": 4900,
	"./gallery_06.jpg": 4901,
	"./gallery_07.jpg": 4902,
	"./gallery_08.jpg": 4903,
	"./gallery_09.jpg": 4904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4894;